import I18n from '../../i18n';
I18n.translations || (I18n.translations = {});
I18n.translations["ja"] = I18n.extend((I18n.translations["ja"] || {}), JSON.parse('{"layouts":{"footer":{"follow_us":"フォローする","logo_banner_alt":"Reeracoen Freelance Recruiting Business"},"header":{"login":"ログイン","logo_banner_alt":"Reeracoen Freelance Recruiting Business","logout":"ログアウト","register":"登録"}}}'));
